module.exports = __webpack_public_path__ + "img/about-77.67bfe84c.png";